import { useEffect, useRef, useState } from "react";
import { ReactComponent as CloudArrowUpIcon } from "../assets/Upload icon.svg"; // or swap in your own SVG
import {ReactComponent as FileXSLX} from "../assets/FileXls.svg"
import {ReactComponent as Remove} from "../assets/remove.svg"
import { fi, he } from "date-fns/locale";
import { Button } from "../Components/Helper";

export default function DragExcelUploader({ onFileSelect }) {
  const fileInputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);
  const [file, setFile] = useState(null);

  const handleBrowseClick = () => {fileInputRef.current?.click();}
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    console.log(file)
    if (file) setFile(file);
  };

  useEffect(()=>{
    console.log(file)
  },[file])

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    // if (file) onFileSelect(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleSubmit = ()=>{
    if(fileInputRef.current.files.length > 0){
      const file = fileInputRef.current.files[0];
      onFileSelect(file);
  }
}

  const handleDragLeave = () => setDragOver(false);

  const fileSize = (size) => {

    const sizeInBytes = 8697;
const sizeInKB = sizeInBytes / 1024;

const displaySize = sizeInKB >= 1024
  ? (sizeInKB / 1024).toFixed(2) + ' MB'
  : sizeInKB.toFixed(2) + ' KB';

  return displaySize
  }

  return (
    <div style={{height:"80%",paddingLeft:"47px",paddingRight:"58px",paddingBottom:"25px"}} className=" bg-white shadow-md rounded-lg space-y-6">
      {/* Mandatory fields */}
      {/* <div className="text-center">
        <span className="text-base font-medium text-gray-700">
          Mandatory fields:
        </span>{" "}
        <b className="text-sm">Name</b>, <b className="text-sm">Phone</b>,{" "}
        <b className="text-sm">State</b>
      </div> */}

      {/* Drag & Drop zone */}
      <div  style={{height:"285px"}}
        onClick={handleBrowseClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        className={`cursor-pointer border-2 border-dashed rounded-lg py-12
                    flex flex-col items-center justify-center
                    transition-colors
                    ${dragOver ? "border-blue-500 bg-blue-50" : "border-blue-300 bg-blue-50"}`}
      >
        {file ? (
            <>
            <div style={{display:"flex",marginLeft:"10px"}}>
        <FileXSLX style={{width:"56px"}} className="w-12 h-12 text-blue-500 mb-1" />
        <Remove style={{width:"19px",marginTop:"-10px",marginLeft:"-13px"}} className=" text-blue-500" />
        </div>
        <p style={{color:"#0F5EFF",fontWeight:600,fontSize:"14px"}} className="text-lg font-medium text-gray-800 mb-1">
          {file.name}
        </p>
        <p style={{fontSize:"10px",marginTop:"-8px"}} className="text-sm text-gray-500">
        {fileSize(file.size)}
        </p>
        </>
        ) :(
            <>
        <CloudArrowUpIcon className="w-12 h-12 text-blue-500 mb-1" />

        <p style={{fontWeight:600,fontSize:"14px"}} className="text-lg font-small text-gray-800 mb-1">
          Drag & drop files or{" "}
          <span className="text-blue-600 underline">Browse</span>
        </p>
        <p style={{fontSize:"10px"}} className="text-sm text-gray-500">
          Upload a .xls to import customers data to your portal
        </p>
        </>
        )
    }

        

        {/* hidden file input */}
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx"
          className="hidden"
          onChange={handleFileChange}
        />
      </div>

      {/* Upload button */}
      <div style={{ display: "flex", justifyContent: "space-between",marginTop:"14px" }}>
        
      <Button
        isDisabled={!file}
        onClick={handleSubmit}
        text={"UPLOAD FILE"}
        className="btn-large"
        style={{width:"100%"}}
      >
        UPLOAD FILE
      </Button>
      </div>
    </div>
  );
}
